// extracted by mini-css-extract-plugin
export default {"text_module":"pdp-text_module","title":"pdp-title","tm_container":"pdp-tm_container","tm_image":"pdp-tm_image"};